import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { Product } from "src/app/modals/product.model";
@Component({
  selector: "estrella-calificacion",
  templateUrl: "./estrella-calificacion.component.html",
  styleUrls: ["./estrella-calificacion.component.sass"],
})
export class EstrellaCalificacionComponent {
  @Input() product: Product = new Product();
}
